export default __webpack_public_path__ + "78e095d720bc8d6fd509b85ec4ad8c61.png";